import { JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class ProjectConverter implements JsonCustomConvert<Project> {
  serialize() { }
  deserialize(data: any): Project {
    const project = new Project();
    project.projectId = data?.projectId ?? "";
    project.name = data?.name ?? "";
    project.description = data?.description ?? "";
    project.createdAt = data?.createdAt ?? "";
    project.updatedAt = data?.updatedAt ?? null;
    return project;
  }
}

@JsonConverter
export class ProjectArrayConverter implements JsonCustomConvert<Array<Project>> {
  serialize() { }
  deserialize(data: any): Array<Project> {
    const converter = new ProjectConverter();
    return (data ?? []).map((item: any) => converter.deserialize(item));
  }
}

@JsonConverter
export class ProjectListConverter implements JsonCustomConvert<ProjectCountList> {
  serialize() { }
  deserialize(data: any): ProjectCountList {
    const list = new ProjectCountList();
    list.count = Number(data?.count ?? 0);
    list.items = new ProjectArrayConverter().deserialize(data?.items ?? data?.data ?? []);
    return list;
  }
}

@JsonObject("Project")
export class Project {
  @JsonProperty("projectId", String, true)
  projectId: string = "";
  @JsonProperty("name", String, true)
  name: string = "";
  @JsonProperty("description", String, true)
  description: string = "";
  @JsonProperty("createdAt", String, true)
  createdAt: string = "";
  @JsonProperty("updatedAt", String, true)
  updatedAt: string | null = null;
}

@JsonObject("ProjectCountList")
export class ProjectCountList {
  @JsonProperty("count", Number, true)
  count: number = 0;
  items: Array<Project> = [];
}

@JsonObject("ProjectData")
export class ProjectData extends BaseResponse {
  @JsonProperty("data", ProjectConverter, true)
  data: Project = new Project();
}

@JsonObject("ProjectDataArray")
export class ProjectDataArray extends BaseResponse {
  @JsonProperty("data", ProjectListConverter, true)
  data: ProjectCountList = new ProjectCountList();
}

@JsonObject("ProjectCreateResponse")
export class ProjectCreateResponse extends BaseResponse {
  @JsonProperty("data", String, true)
  data: string = "";
}
